export default __webpack_public_path__ + "static/media/Stage5_correct.07c39daf.svg";